<main>
  <ng-template staticPageHost></ng-template>
  <ng-container *ngIf="layoutDetails.hasCustomLayout || blogEntry">
    <thema-core-custom-layout
      [content]="content"
    ></thema-core-custom-layout>
  </ng-container>
</main>
